export default {
	title: "Personlig Senter",
	subTitle: ["Profil", "Sikkerhet", "System"],
	menu: ["Endre Personlig Informasjon", "Brukernavn", "Oppdater Passord", "Oppdater Transaksjons Passord"],
	updatePassword: {
		form: {
			label: ["Gammelt Passord", "Nytt Passord", "Bekreft Nytt Passord"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Gammelt Passord", "Nytt Passord", "Bekreft Nytt Passord"]
		}
	}
};
